import styled from 'styled-components'

const ErrorPageStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0;
  margin: 0;
  width: 100dvw;
  min-height: 100dvh;
  color: #444f56;

  h1 {
    margin-bottom: 0;
    font-size: 22px;
    color: #444f56;

  }

  .spinner-container {
    position: relative;
    display: block;
    height: 100px;
    margin-bottom: 10px;
  }

  .tryAgainButton {
    margin: 24px 0;
  }

  .error-message-container {
    display: flex;
    justify-content: left;
    margin-top: 32px;
    color: #444f56;
  }

  .error {
    display: block;
    margin-top: 14px;
  }
`

export default ErrorPageStyled
